$(document).ready(function(){

    function scrollToSection(sectionId, topOffset = 0) {
        var $section = $(sectionId);

        if (!$section.length) {
            console.warn('Scroll section not found:', sectionId);
            return;
        }

        var sectionOffset = $section.offset();

        if (!sectionOffset) {
            return;
        }

        var offset = sectionOffset.top - topOffset;

        $('html, body').animate({
            scrollTop: offset
        }, 100);
    }

	$(document).on(
		'click',
		'.js-calendly-multiselect a.btn-alt-secondary',
		function (event) {

			event.preventDefault();

			var $link = $(this);

			var $multiselect = $link.closest(
				'.js-calendly-multiselect'
			);

			/*
			 * The multiselect and Calendly container
			 * are inside the same parent wrapper.
			 */
			var $block = $multiselect.parent();

			var $widget = $block.find(
				'.js-calendly-container .calendly-inline-widget'
			).first();

			var url = $link.attr('href');

			if (!url || url === '#' || !$widget.length) {
				return false;
			}

			if (
				typeof window.Calendly === 'undefined' ||
				typeof window.Calendly.initInlineWidget !== 'function'
			) {
				console.error('Calendly script is not loaded.');

				return false;
			}

			var calendlyUrl = new URL(url);

			calendlyUrl.searchParams.set(
				'hide_gdpr_banner',
				'1'
			);

			/*
			 * Update the active link.
			 */
			$multiselect
				.find(
					'.js-meet-with-us-team a.btn-alt-secondary'
				)
				.removeClass('is-active');

			$link.addClass('is-active');

			/*
			 * Remove the previously generated Calendly iframe.
			 */
			$widget.empty();

			/*
			 * Update the data-url attribute.
			 */
			$widget.attr(
				'data-url',
				calendlyUrl.toString()
			);

			/*
			 * Initialize the new Calendly form
			 * inside the existing widget.
			 */
			window.Calendly.initInlineWidget({
				url: calendlyUrl.toString(),
				parentElement: $widget[0],
			});

            /*
			 * Scroll to the Calendly section.
			 * 80 is the sticky header offset.
			 */
			scrollToSection('#calendly-container', 80);

			return false;
		}
	);

});
